/**
 * Hide Stamped product-card badges when a product has no reviews.
 * Stamped often renders empty star outlines without data-reviews="0".
 */
(function () {
  function parseCount(value) {
    if (value === null || value === undefined || value === '') return null;
    var n = parseInt(String(value), 10);
    return Number.isNaN(n) ? null : n;
  }

  function getReviewCount(badge) {
    var container = badge.querySelector('.stamped-container');
    if (container) {
      var fromContainer = parseCount(container.getAttribute('data-count'));
      if (fromContainer !== null) return fromContainer;
    }

    var fromBadge = parseCount(badge.getAttribute('data-reviews'));
    if (fromBadge !== null) return fromBadge;

    var caption = badge.querySelector('.stamped-badge-caption, .stamped-badge-caption-data');
    if (caption) {
      var match = caption.textContent.match(/(\d+)\s*review/i);
      if (match) return parseInt(match[1], 10);
    }

    return null;
  }

  function hasFilledRating(badge) {
    if (badge.querySelector('.stamped-fa-star-half-o')) return true;
    var stars = badge.querySelectorAll('.stamped-starrating .stamped-fa, .stamped-starratings .stamped-fa');
    for (var i = 0; i < stars.length; i++) {
      var star = stars[i];
      if (star.classList.contains('stamped-fa-star') && !star.classList.contains('stamped-fa-star-o')) {
        return true;
      }
    }
    return false;
  }

  function shouldHideBadge(badge) {
    if (!badge.innerHTML.trim()) return true;

    if (badge.querySelector('.stamped-container[data-count="0"]')) return true;
    if (badge.getAttribute('data-reviews') === '0') return true;

    var count = getReviewCount(badge);
    if (count === 0) return true;

    var caption = badge.querySelector('.stamped-badge-caption, .stamped-badge-caption-data');
    if (caption) {
      var captionText = caption.textContent.trim();
      if (/^0(\s|$)/i.test(captionText) || /0\s*review/i.test(captionText)) return true;
    }

    var badgeText = badge.textContent.replace(/\s+/g, ' ').trim();
    if (/0\s*review/i.test(badgeText)) return true;

    if (count === null && !hasFilledRating(badge) && badge.querySelector('.stamped-fa-star-o')) {
      return true;
    }

    if (count === null && badgeText && !/\d/.test(badgeText) && badge.querySelector('.stamped-fa-star-o')) {
      return true;
    }

    return false;
  }

  function updateWrapper(wrapper) {
    if (wrapper.classList.contains('stamped-product-stars--placeholder')) return;

    var badge = wrapper.querySelector('.stamped-product-reviews-badge');
    var hide = !badge || shouldHideBadge(badge);

    wrapper.classList.add('stamped-product-stars--ready');
    wrapper.classList.toggle('stamped-product-stars--empty', hide);
    wrapper.classList.toggle('stamped-product-stars--has-reviews', !hide);
    wrapper.hidden = hide;
  }

  function updateAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.stamped-product-stars').forEach(updateWrapper);
  }

  function observeBadge(badge) {
    if (badge.__ljwStampedObserved) return;
    badge.__ljwStampedObserved = true;

    var wrapper = badge.closest('.stamped-product-stars');
    if (!wrapper) return;

    var observer = new MutationObserver(function () {
      updateWrapper(wrapper);
    });
    observer.observe(badge, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-count', 'data-reviews', 'data-rating', 'class', 'style'],
    });
    updateWrapper(wrapper);
  }

  function bindBadges() {
    document.querySelectorAll('.stamped-product-reviews-badge').forEach(observeBadge);
    updateAll();
  }

  function init() {
    bindBadges();

    if (window.__ljwStampedBodyObserver) return;
    window.__ljwStampedBodyObserver = true;

    var bodyObserver = new MutationObserver(function () {
      bindBadges();
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  function scheduleUpdates() {
    [100, 400, 800, 1500, 3000].forEach(function (delay) {
      setTimeout(updateAll, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', function () {
    init();
    scheduleUpdates();
  });

  var previousInit = window.stampedThemeInit;
  window.stampedThemeInit = function () {
    if (typeof previousInit === 'function') previousInit();
    init();
    scheduleUpdates();
  };
})();
